import React, { useState, useEffect}  from 'react';
import { DataContext } from '../App';
import { Bar } from "react-chartjs-2";
import {
    LineElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip,
    PointElement
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

ChartJS.register(
    CategoryScale,
    LinearScale,
    LineElement,
    Title,
    Tooltip,
    Legend,
    PointElement
);

ChartJS.register(annotationPlugin);

const {getPadding, average, min, max} = require('../utils.js');

function FruitFlyTraffic(){
    const data = React.useContext(DataContext);
   
    const hours = ["3am", "", "5am", "", "7am", "", "9am", "", "11am", "", "1pm", "", "3pm", "", "5pm", "", "7pm", "", "9pm"]
    var historicalHourlyFruitflyTraffic = data.historical_hourly_fruitfly_traffic;

    const chartdata = {
        labels: hours.slice(2,historicalHourlyFruitflyTraffic.length - 2),
        datasets: [{
            label: '# of Votes',
            data: historicalHourlyFruitflyTraffic.slice(2,historicalHourlyFruitflyTraffic.length - 2),
            backgroundColor: '#282880',
            borderRadius: 10,
            borderSkipped: false
        }]
    };
    
    const options = {
        scales: {
            y: {
                beginAtZero: true,
                max: max(historicalHourlyFruitflyTraffic) + 1,
                min: -1,
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: false,
                }
            },
            x: {
                grid: {
                    display: false,
                    borderColor: '#FFFFFF',
                    drawTicks: false
                },
                ticks: {
                    display: true,
                    maxRotation: 45,
                    minRotation: 45
                }
            }
        },
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            },
            autocolors: false
        }
    };

    return(
        <div className="card-body">
            <div style={{height:"180px"}}>
                <Bar
                    data={chartdata}
                    options={options}
                />
            </div>
        </div>

    );

}

export default FruitFlyTraffic;